namespace TabAurous.Production {
    export interface JobWorkSettlementForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        PartyId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        Weight: Serenity.DecimalEditor;
        KnockOff: Serenity.DecimalEditor;
        Details: JobWorkSettlementDetailsEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class JobWorkSettlementForm extends Serenity.PrefixedContext {
        static formKey = 'Production.JobWorkSettlement';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JobWorkSettlementForm.init)  {
                JobWorkSettlementForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = JobWorkSettlementDetailsEditor;

                Q.initFormType(JobWorkSettlementForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'VoucherTypeId', w2,
                    'VoucherNo', w0,
                    'PartyId', w3,
                    'LedgerName', w0,
                    'ProductTypeId', w3,
                    'Weight', w4,
                    'KnockOff', w4,
                    'Details', w5,
                    'CompanyId', w2,
                    'FinancialYearId', w2
                ]);
            }
        }
    }
}
